import { Component, inject } from '@angular/core';
import { LayoutService } from '../../../core/services/layout.service';
import { AppContextService } from 'src/app/core/services/app-context.service';
import { CartService } from 'src/app/core/services/ecommerce/cart.service';
import { MenuSection } from '../../../shared/models/layout.model';
import { AppRoutes } from 'src/app/core/models/routes.model';

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss'],
    standalone: false
})
export class SidebarComponent {
  private readonly cartService = inject(CartService);

  constructor(
    public layoutService: LayoutService,
    private readonly appContextService: AppContextService
  ) {}

  // Numero di righe del carrello come badge; nascosto quando il carrello è vuoto.
  private get cartItemsBadge(): string | undefined {
    const count = this.cartService.cart()?.lines.length ?? 0;
    return count > 0 ? String(count) : undefined;
  }

  get topBar(): MenuSection[] {
    const items: MenuSection[] = [];

    const selectedAppCode = this.appContextService.currentAppCode();

    if (!selectedAppCode) {
      return items;
    }

    return [
      ...items,
      {
        label: 'Piani',
        icon: 'pi pi-th-large',
        url: this.appContextService.buildAppScopedUrl(AppRoutes.DASHBOARD),
        children: [],
      },
      {
        label: 'Carrello',
        icon: 'pi pi-shopping-cart',
        url: this.appContextService.buildAppScopedUrl(AppRoutes.CARRELLO),
        badge: this.cartItemsBadge,
        children: [],
      },
      {
        label: 'Acquisti',
        icon: 'pi pi-shopping-bag',
        url: this.appContextService.buildAppScopedUrl(AppRoutes.ACQUISTI),
        children: [],
      },
    ];
  }

  // La pagina profilo è nascosta (15/09/2026): nessuna voce in fondo al menu.
  get bottomBar(): MenuSection[] {
    return [];
  }
}
